import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m25.849 27.971 6.323 6.322c.63.63.183 1.707-.707 1.707H18.82c-.891 0-1.337-1.077-.707-1.707l6.322-6.322a1 1 0 0 1 1.414 0ZM29.05 34l-3.908-3.908L21.234 34h7.816Zm-4.616-4.615ZM34 29.05V12.093l-8.479 8.479L34 29.05ZM30.194 6H10.95l9.622 9.622L30.194 6ZM6 19.326l4.37-4.006L6 10.95v8.376ZM6 34v-5.178l9.324-8.547 4.868 4.868L11.335 34H6ZM33.315 5.707c.63-.63.184-1.707-.707-1.707H8.536c-.891 0-1.338 1.077-.708 1.707l12.036 12.036a1 1 0 0 0 1.415 0L33.315 5.707ZM36 31.465c0 .89-1.077 1.336-1.707.707L23.4 21.279a1 1 0 0 1 0-1.415L34.293 8.973c.63-.63 1.707-.184 1.707.707v21.785ZM5.707 7.828C5.077 7.198 4 7.645 4 8.536v13.063c0 .87 1.034 1.325 1.676.737l6.815-6.248a1 1 0 0 0 .032-1.444L5.707 7.828ZM4 28.382a1 1 0 0 1 .324-.738l10.354-9.49a1 1 0 0 1 1.383.03l6.252 6.252a1 1 0 0 1 0 1.414l-9.857 9.857a1 1 0 0 1-.707.293H5a1 1 0 0 1-1-1v-6.618Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var PictogramMapMainPlan40 = createIcon(IconComponent);